import { PropsWithChildren, useCallback } from 'react';
import React from 'react';
import { EsriFeaturePicker } from '@/features/build-calculation-context/components/Home/components/ArcGisMapContainer/EsriFeaturePicker';
import { Map } from '@/features/build-calculation-context/components/Home/components/ArcGisMapContainer/Map';
import { MapProvider } from '@/features/build-calculation-context/components/Home/components/ArcGisMapContainer/MapProvider';
import { MapViewProvider } from '@/features/build-calculation-context/components/Home/components/ArcGisMapContainer/MapViewProvider';
import { useActions, useAppState } from '@/overmind';

type MapClickEventPayload = {
  features: any[];
  graphics: any[];
  mapInteractionLocation: { x: number; y: number } | null;
}

export function SplitViewMap({ children }: PropsWithChildren) {
  const featuresInLayers = useAppState().arcgis.featureGeometries.value;
  const selectedFeature = useAppState().selectedFeature.current
  const { withExtent, onViewInitialized } = useActions().map
  const [{ features, graphics, mapInteractionLocation }, setFeatures] =
    React.useState<MapClickEventPayload>({
      features: [],
      graphics: [],
      mapInteractionLocation: null
    });
  const _withExtent = useCallback(withExtent, []);
  const _onViewInitialized = useCallback(onViewInitialized, []);
  const EsriMapContainer = React.useMemo(
    () => (
      <MapProvider>
        <MapViewProvider>
          <Map
            onClick={setFeatures}
            unselectFeature={!Boolean(selectedFeature)}
            withExtent={_withExtent}
            onViewInitialized={_onViewInitialized}
          />
        </MapViewProvider>
      </MapProvider>
    ),
    [_withExtent, featuresInLayers]
  );
  return (
      <>
        {EsriMapContainer}
        <EsriFeaturePicker
          features={features}
          graphics={graphics}
          mapInteractionLocation={mapInteractionLocation}
        />
      </>
      )
}
